//package imports 
import React, { useEffect, useState } from "react";
import { useRouteMatch, useHistory, useParams } from "react-router-dom";

//component imports
import { CusotomSearch } from "../../utils/resuableComponents/CustomSearch";
import CustomTable from "../../utils/resuableComponents/CustomTable";
import { GetUserList } from "../../services/apiServices/PostServices";
import { getUserType, getCityList, getStateList } from "../../services/apiServices/GetServices";
import { disableUser } from "../../services/apiServices/PostServices";
import { getData } from "../../utils/AsyncStorage";
import { columnsUserList } from "../../utils/constants/TableHeader";
import CustomModal from "../../utils/resuableComponents/CustomModal";
import { showToast } from "../../utils/constants/Toaster";
import { CustomMutilevelDropdown } from "../../utils/resuableComponents/Filters";
import Loader from "../loadingScreens/Loader";


const UserManagement = (props) => {
    const [userData, setUserData] = useState([])
    const { role } = JSON.parse(getData("userInfo") || 0);
    const [searchTerm, setSearchTerm] = useState('');
    const history = useHistory();
    const [filteredData, setFilteredData] = useState([])
    const [simpleModal, setSimpleModal] = useState(false)
    const [declineStatus, setDeclineStatus] = useState("")
    const [disabledStaus, setDisabledStatus] = useState("")
    const [userTypeData, setUserTypeData] = useState([])
    const [cityListData, setCityListData] = useState([])
    const [stateData, setStatesData] = useState([])
    const [userId, setUserId] = useState("")
    const params = useParams()
    const [data, setData] = useState([])
    const closeSimpleModal = () => setSimpleModal(false)
    const [fileterApplied, setFilterApplied] = useState(false)
    const [appliedFilterData, setAppliedFilterData] = useState([])
    const [isLoader,setIsLoader]=useState(false)

    const pathName = "/admin/userManagement/userDetailedView"

    useEffect(() => {
        getUserListApi()
        callUserTypelistApi()
        callStateslistApi()
    }, []);


    useEffect(() => {
        if (filteredData.length != 0) {
            setData(filteredData)
        }
    }, [filteredData.length])

    //function to call api of the getUserList
    const getUserListApi = async () => {
        setIsLoader(true)
        try {
            const reqbody = {
                role: 3,
                city: "",
                is_active: ""
            }
            const res = await GetUserList("userList", reqbody);

            if (res.success) {
                setFilteredData(res?.data)
                setUserData(res?.data)
            } else {
                console.log("res", res?.message)
            }
        } catch (error) {
            console.log("error", error)
        }

    }

    //function to call list api
    const callStateslistApi = async () => {
        try {
            const res = await getStateList("state/1")
            if (res?.success) {
                setStatesData(res?.data)
            } else {
                console.log("res", res?.message)
            }
        } catch (error) {
            console.log("error", error)
        }
    }

    //function to userType type api
    const callUserTypelistApi = async () => {
        try {
            const res = await getUserType("userType")
            if (res?.success) {
                setUserTypeData(res?.data)
            } else {
                console.log("res", res?.message)
            }
        } catch (error) {
            console.log("error", error)
        }
    }

    //function to clear applied filter
    const handleClear = () => {
        getUserListApi()
        setFilterApplied(false)
    }

    const handleReqbody = async (reqBody) => {
        try {
            const reqbody = reqBody
            const res = await GetUserList("userList", reqbody);
            if (res?.success) {
                setFilterApplied(true)
                setFilteredData(res?.data)
                setAppliedFilterData(res?.data)
            } else {
                console.log("res", res?.message)
            }
        } catch (error) {
            console.log("error", error)
        }
    }

    //function to hanlde search
    const handleSearch = (val) => {
        const searchVal = val
        if (searchVal === "") {
            if (fileterApplied) {
                setFilteredData(appliedFilterData)
                setUserData(appliedFilterData)
            } else {
                getUserListApi()
            }
        }
        else {
            setSearchTerm(searchVal);
            const filterdata = userData.filter((item) => {
                if (item?.name !== null ? item?.name.toLowerCase()
                    .includes(searchVal.toLowerCase()) : "" || item?.city_name !== null ? item?.city_name.toLowerCase()
                        .includes(searchVal.toLowerCase()) : "" || item?.email !== null ? item?.email.toLowerCase().includes(searchVal.toLowerCase()) : "" || item?.phone_number.includes(searchVal)) { return item; }
            })
            setFilteredData(filterdata)
        }
    }

    //function handle create profile 
    const handleCreateProfile = () => {
        history.push('/admin/createProfile')
    }

    //function call to hit disable api.
    const handledisable = async () => {
        const endpoint = `disable_user/${disabledStaus}`
        const reqBody = {
            id: userId
        }
        const res = await disableUser(`${endpoint}`, reqBody);
        if (res?.success) {
            setSimpleModal(false)
            showToast(1, "User disabled Successfull")
        } else {
            //showToast(3, res?.message)
            console.log("res", res?.message)
        }
    }

    //function call to open modal
    const handleStatus = async (value, data) => {
        value === 1 ? setDisabledStatus("true") : setDisabledStatus("false")
        setUserId(data?.id)
        if (value === 0) {
            setSimpleModal(true)
            setDeclineStatus("")
        }
    }

    return (
        <div class="col-md-12 " >
            {isLoader ? <Loader/> : null }
            <div class="d-flex flex-row  justify-content-between align-items-center w-100 border-bottom p-2">
                <h1 class="fs-4 mx-3 Montserrat fw-semi-bold">
                    User Management
                </h1>
                <div class="d-flex flex-row ">
                    <div class="d-flex mx-2 pointer " onClick={handleCreateProfile}>
                        <h6 class="secondColor d-flex justify-content-center align-items-center fw-bold mx-2 m-0 w-100">
                            Create Users
                        </h6>
                        <i class="bi bi-plus-square colorPrimary"></i>
                    </div>
                    <CustomMutilevelDropdown reqBody={handleReqbody}  clear={handleClear} cityData={cityListData} userType={userTypeData} stateData={stateData} />
                </div>
            </div>
            <div class="d-flex justify-content-start">
                <CusotomSearch onChange={handleSearch} searchVal={searchTerm} />
            </div>

            <CustomTable data={filteredData} columnHeader={columnsUserList}
                onStausChange={handleStatus}
                path={pathName}
                switchDecline={declineStatus}
            />
            <CustomModal
                //   close={handleClose}
                close={closeSimpleModal}
                open={simpleModal}
                modalContent={"Are you sure want to disable the user?"}
                Action={handledisable}
            />
        </div>
    )
}

export default UserManagement